import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SimpleFilterChoiceShape } from 'utils/shapes';

import NewsListFilter from 'components/news/NewsListFilter';
import NewsList from 'components/news/NewsList';
import { setFilters } from 'ducks/newslist';
import reverseUrl from 'utils/urls';
import { gettext } from '../../utils/text';

const mapDispatchToProps = (dispatch) => ({
    setFilters: (filters) => dispatch(setFilters(filters)),
});

@connect(null, mapDispatchToProps)
class NewsListWrapper extends Component {
    static propTypes = {
        setFilters: PropTypes.func.isRequired,
        filterChoices: PropTypes.arrayOf(SimpleFilterChoiceShape.isRequired).isRequired,
        selectedFilterKey: PropTypes.string.isRequired,
        query: PropTypes.string.isRequired,
    };

    componentDidMount = () => {
        const { filterChoices, selectedFilterKey, query } = this.props;
        const filters = {
            query,
            choices: filterChoices,
        };

        // If category was set in the URL and it is a valid category codename
        // if not, try setting if to All
        // if even that fails, get first filter available
        if (selectedFilterKey && filterChoices.find((filter) => filter.key === selectedFilterKey)) {
            filters.filterKey = selectedFilterKey;
        } else if (filterChoices.find((filter) => filter.key === 'all')) {
            filters.filterKey = 'all';
        } else {
            filters.filterKey = filterChoices[0].key;
        }

        // Set all filters in single action
        this.props.setFilters(filters);
    };

    render() {
        return (
            <div>
                <div className="arena__header">
                    <div className="arena__header__title arena__header__right">
                        <h2>{gettext('News')}</h2>
                    </div>
                </div>
                <NewsListFilter setTitle />
                <NewsList />
            </div>
        );
    }
}

export default NewsListWrapper;



// WEBPACK FOOTER //
// ./src/components/news/NewsListWrapper.js